import axios from "axios";
import {useConfigStore} from "@/stores/config.ts";

export default class BaseApi {
    private baseUrl: string = useConfigStore().baseUrl;
    protected version: string = 'v3';
    protected baseEndPoint: string|null = null;

    public get axios() {
        return  axios.create({
            baseURL: this.buildUrl()
        });
    }

    protected buildUrl(): string {
        const baseUrl = `${this.baseUrl.replace(/\/$/, '')}/api/company-registration/${this.version}`;

        if (!this.baseEndPoint) {
            return  baseUrl;
        }

        return `${baseUrl}/${this.baseEndPoint}`;
    }
}